import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sunrise, BookOpen, HandHeart, Heart, UserCircle2, ShieldCheck } from "lucide-react";

export default function BottomNav() {
  const { user } = useAuth();

  const items = [
    { to: "/", label: "Inicio", icon: Sunrise, end: true },
    { to: "/archivo", label: "Archivo", icon: BookOpen },
    { to: "/oracion", label: "Oración", icon: HandHeart },
    ...(user ? [{ to: "/favoritos", label: "Favoritos", icon: Heart }] : []),
    { to: user ? "/cuenta" : "/login", label: "Cuenta", icon: UserCircle2 },
  ];
  if (user?.is_admin) {
    items.push({ to: "/admin", label: "Admin", icon: ShieldCheck });
  }

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/85 md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="mx-auto flex h-16 max-w-md items-stretch justify-around">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex min-w-[56px] flex-col items-center justify-center gap-0.5 px-2 text-[11px] font-medium transition-colors duration-200 ${
                isActive ? "text-primary" : "text-muted-foreground"
              }`
            }
            data-testid={`bottom-nav-${item.label.toLowerCase()}`}
          >
            {({ isActive }) => (
              <>
                <span className={`flex h-8 w-12 items-center justify-center rounded-full transition-colors duration-200 ${isActive ? "bg-accent" : ""}`}>
                  <item.icon className="h-5 w-5" />
                </span>
                {item.label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
